export const getCalendar = (state) => state.calendarR.calendar;
export const getCalendarStatus = (state) => state.calendarR.calendarStatus;
export const getCalendarLoading = (state) => state.calendarR.calendarLoading;